<template>
  <Modal>
    <Modal.Title>Next billing</Modal.Title>
    <Modal.Body>
      <UpcomingBillingDetailsBody :details="details" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'

import type { BillingPlanDetails } from '@/shared/graphql/legacy/generated'
import UpcomingBillingDetailsBody from './UpcomingBillingDetailsBody.vue'

defineProps<{
  details: BillingPlanDetails
}>()
</script>
